module.exports = __webpack_public_path__ + "static/media/walnuts.23d8e0cc.jpg";